import { MainInner } from "@/styles/global";
import {
  DetailsBig,
  ParagraphIngress,
  SecondaryButtonCss,
  TextLinkCss,
  Wysiwyg,
  h2,
  h2Css,
  h6,
} from "@/styles/typography";
import styled from "styled-components";
import { GatsbyImage } from "gatsby-plugin-image";

const Inner = styled(MainInner)`
  display: flex;
  gap: 24px;
  flex-direction: column-reverse;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    justify-content: space-between;
    position: relative;
    top: 0;
    right: 0;
    flex-direction: row;
  }

  @media print {
    padding: 0;
    margin: 0;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    width: 68%;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const TextContent = styled(Wysiwyg)``;

const H2 = styled(h2)`
  @media print {
    display: none;
  }
`;

const Ingress = styled(ParagraphIngress)``;

const Image = styled(GatsbyImage)`
  aspect-ratio: 3/2;
  border-radius: 4px;
`;

const VimeoHero = styled.div`
  width: 100%;
  aspect-ratio: 16/9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;

  iframe {
    border-radius: 4px;
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    border: none;
    background: ${({ theme }) => theme.colors.coreDark};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 24px;
  }
`;

const VideoWrapper = styled.div`
  position: relative;

  @media print {
    display: none;
  }
`;

const LinkBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 24px;
  }

  @media print {
    gap: 16px;
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media print {
    gap: 4px;
  }
`;

const LinkTitle = styled.span`
  display: none;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    ${TextLinkCss}
    margin-right: 8px;
  }
`;

const ExternLink = styled.a`
  ${TextLinkCss}
  color: ${({ theme }) => theme.colors.primaryPurple};

  svg {
    margin-left: 8px;
  }

  &:hover {
    text-decoration: underline;
  }
`;

const IconWrapper = styled.div`
  transform: scale(-1, 1);
  top: -30px;
  position: absolute;
  right: -40px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    top: -20px;
    right: -10px;

    svg {
      width: 32px;
      height: 36px;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    top: -30px;
    right: -40px;
  }
`;

const FlexWrapper = styled.div`
  display: flex;
  gap: 16px;

  @media print {
    display: none;
  }
`;

const SoMeWrapper = styled.button`
  display: flex;
  gap: 16px;
  background: transparent;
  border: none;

  svg path {
    fill: ${({ theme }) => theme.colors.primaryPurple};
  }

  @media print {
    display: none;
  }
`;

const DetailsLarge = styled(DetailsBig)``;

const PrintButton = styled.button`
  ${SecondaryButtonCss};
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.textHeading};
  }

  @media print {
    display: none;
  }
`;

const PrintTitle = styled.h2`
  display: none;
  margin: 24px 0;
  ${h2Css}

  @media print {
    display: block;
  }
`;

const InfoTitle = styled(h6)`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const S = {
  Inner,
  FlexWrapper,
  Wrapper,
  TextContent,
  TextContainer,
  H2,
  Ingress,
  Image,
  VimeoHero,
  VideoWrapper,
  LinkWrapper,
  LinkTitle,
  ExternLink,
  LinkBlockContainer,
  PrintButton,
  IconWrapper,
  SoMeWrapper,
  DetailsLarge,
  PrintTitle,
  InfoTitle,
};

export default S;
